<template>
  <div class="contenedor">
    <div class="flex-column d-flex justify-content-center text-black aboutus">
      <div class="texto">
        <div class="row m-0">
          <h1 class="text-center font-weight-bold my-3 col" id="nosotros"> - Tlapaleria Piedra - </h1>
        </div>
        <div class="d-flex justify-content-center align-items-center flex-wrap">
          <div class="text-center w-50">
            <h2>Nosotros</h2>
            <p class="text-justify">Somos una ferretera que busca brindar todo lo necesario a la gente para la construcción de su hogar.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-column d-flex justify-content-center s2">
      <div class="row m-0">
        <h2 class="text-center font-weight-bold my-3 col" id="marcas">Marcas</h2>
      </div>
      <div class="row m-0">
        <p class="text-center font-weight-bold my-3 col">Las marcas que tenemos para ti:</p>
      </div>
      <div class="d-flex justify-content-center align-items-center flex-wrap">
        <img class="w-25 m-2" src="https://www.truper.com/skin/frontend/glam/default/images/logo_header.png" alt=""/>
        <img class="w-25 m-2" src="https://www.aksi.com.mx/img/Content/logo.png" alt=""/>
        <img class="w-25 m-2" src="https://www.truper.com/media/home_brands/pretul.png" alt=""/>
        <img class="w-25 m-2" src="https://www.truper.com/media/home_brands/foset.png" alt=""/>
        <img class="w-25 m-2" src="https://www.truper.com/media/home_brands/fierro.png" alt=""/>
        <img class="w-25 m-2" src="https://www.truper.com/media/home_brands/hermex.png" alt=""/>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-center s3">
      <div  class="d-flex flex-column justify-content-center">
        <h2 class="text-center font-weight-bold my-3 col" id="marcas">Ubicación</h2>
        <div class="d-flex justify-content-center align-items-center flex-wrap">
          <div class="mr-3 w-50">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1520.8416012700718!2d-99.15476903906436!3d18.91079138879882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce75a42259d795%3A0x11639c3127dc4202!2sTlapaleria%20Piedra!5e0!3m2!1ses-419!2smx!4v1617122961232!5m2!1ses-419!2smx" class="w-100 h-75" loading="lazy" title="Mapa"></iframe>
          </div>
          <div class="text-center w-25">
            <p class="text-justify">Estamos ubicados en: Colonia Josefa ortiz de dominguez, Calle Nicolás Bravo, 62570 Jiutepec, Mor.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
}
</script>
<style >
.contenedor{
  position:'absolute';
  left:'0'
}
.aboutus{
  height: 80vh;
  background-image:url('../assets/bg-tlapaleria.jpg');
  background-size: cover;
  background-position: center;
  font-weight:900;
  -webkit-text-stroke: .1px black;
}
.texto{
  background-Color:rgba(196, 196, 196, 0.5)
}
.s2{
  height: 80vh;
  background-color: #e5e5e5;
}
.s3{
  height: 80vh;
  background-color: #f0efef;
}
</style>